// src/components/Filter.js

import axios from "axios";
import { useEffect, useState } from "react";

function Filter({ isOpen, onClose, onApply }) {
//   if (!isOpen) return null; // hide when closed
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedSubCategory, setSelectedSubCategory] = useState(null);

  const [timeOfDay, setTimeOfDay] = useState([]);

  // const [priceRange, setPriceRange] = useState([0, 10000]);
  const [priceRange, setPriceRange] = useState([50, 2500]);

  const [duration, setDuration] = useState(null);
  const [guests, setGuests] = useState(1);
  const MIN = 0;
const MAX = 2500;
const [durationRange, setDurationRange] = useState([30, 240]); // default min-max
const durationOptions = [
  { label: "30m", value: 30 },
  { label: "45m", value: 45 },
  { label: "1h", value: 60 },
  { label: "1.5h", value: 90 },
  { label: "2h", value: 120 },
  { label: "3h", value: 180 },
  { label: "4h+", value: 240 },
];


  // 🔹 Fetch categories on open
  useEffect(() => {
    if (isOpen) {
      fetchCategories();
    }
  }, [isOpen]);

  const fetchCategories = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE}/get-category`
      );
      setCategories(res.data.data || []);
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  const fetchSubCategories = async (categoryId) => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE}/get-sub-category`,
        { category_id: categoryId }
      );
      setSubCategories(res.data.data || []);
      setSelectedCategory(categoryId);
      setSelectedSubCategory(null); // reset when category changes
    } catch (error) {
      console.error("Error fetching subcategories:", error);
    }
  };

 
// Filter.js
const handleApply = () => {
  const filtersToSend = {};

  if (selectedCategory) filtersToSend.category_id = selectedCategory;
  if (selectedSubCategory) filtersToSend.sub_category_id = selectedSubCategory;

  // Apply price only when user changes values
  if (priceRange[0] !== 50 || priceRange[1] !== 2500) {
    filtersToSend.from_price = priceRange[0];
    filtersToSend.to_price = priceRange[1];
  }

  // Apply duration only if changed
  if (durationRange[0] !== 30 || durationRange[1] !== 240) {
    filtersToSend.min_duration = durationRange[0];
    filtersToSend.max_duration = durationRange[1];
  }

  if (guests > 1) filtersToSend.guests = guests;

  // checkbox → apply only if selected
  if (timeOfDay) filtersToSend.time_of_day = timeOfDay;

  onApply(filtersToSend);
};




const handleClear = () => {
  setSelectedCategory(null);
  setSelectedSubCategory(null);
  setSubCategories([]);
  setTimeOfDay([]);
  setPriceRange([50, 2500]); 
  setDuration(null);
  setGuests(1);
};


  if (!isOpen) return null;

  return (
    <div className="filter-popup-overlay">
      <div className="all_mld_supports filter-popup">
      
        <div className="top_areea">
         <button className="close-btn" onClick={onClose}> ✕ </button>
         <h3>Filters</h3>
        </div>
		<div className="are_meddils">
		
		<div className="flt_listings">
		 <h4>Category</h4>
           <ul>
  {Array.isArray(categories) && categories.map((cat) => (
    <li key={cat.id} className={selectedCategory === cat.id ? "activelist" : ""}>
      <a
        onClick={() => fetchSubCategories(cat.id)}
        className={selectedCategory === cat.id ? "active" : ""}
      >
        {cat.category}
      </a>
    </li>
  ))}
</ul>

		</div>


		{/* 🔹 SubCategory */}
          {subCategories.length > 0 && (
            <div className="flt_listings">
              <h4>Sub Category</h4>
              <ul>
                {subCategories.map((sub) => (
                  <li key={sub.id} className={selectedSubCategory === sub.id ? "activelist" : ""}>
                    <a
                      onClick={() => setSelectedSubCategory(sub.id)}
                      className={selectedSubCategory === sub.id ? "active" : ""}
                    >
                      {sub.subcategory}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          )}

		<div className="flt_listings price_filtter">
  <h4>Price per guest</h4>

  <div className="slider-container">
    {/* Left thumb */}
    <input
      type="range"
      min={MIN}
      max={MAX}
      step="100"
      value={priceRange[0]}
      onChange={(e) =>
        setPriceRange([
          Math.min(+e.target.value, priceRange[1] - 100),
          priceRange[1],
        ])
      }
      className="thumb thumb-left"
    />

    {/* Right thumb */}
    <input
      type="range"
      min={MIN}
      max={MAX}
      step="100"
      value={priceRange[1]}
      onChange={(e) =>
        setPriceRange([
          priceRange[0],
          Math.max(+e.target.value, priceRange[0] + 100),
        ])
      }
      className="thumb thumb-right"
    />

    {/* Track */}
    <div className="slider">
      <div className="track" />

      {/* Active range (fixed) */}
      <div
        className="range"
        style={{
          left: `${((priceRange[0] - MIN) / (MAX - MIN)) * 100}%`,
          right: `${100 - ((priceRange[1] - MIN) / (MAX - MIN)) * 100}%`,
        }}
      />
    </div>
  </div>

  <p className="flter_renzess">
    <span className="lft_areea">
      Min <span className="flt_tx">{priceRange[0]}$</span>
    </span>
    <span className="rft_areea">
      Max <span className="flt_tx">{priceRange[1]}$</span>
    </span>
  </p>
</div>



		<div className="flt_listings duration_filter">
  <h4>Duration</h4>
  <div className="slider-container">
    <input
      type="range"
      min={durationOptions[0].value}
      max={durationOptions[durationOptions.length - 1].value}
      step={15}
      value={durationRange[0]}
      onChange={(e) =>
        setDurationRange([
          Math.min(+e.target.value, durationRange[1] - 15),
          durationRange[1],
        ])
      }
      className="thumb thumb-left"
    />
    <input
      type="range"
      min={durationOptions[0].value}
      max={durationOptions[durationOptions.length - 1].value}
      step={15}
      value={durationRange[1]}
      onChange={(e) =>
        setDurationRange([
          durationRange[0],
          Math.max(+e.target.value, durationRange[0] + 15),
        ])
      }
      className="thumb thumb-right"
    />

    {/* Track line */}
    <div className="slider">
      <div className="track" />
      <div
        className="range"
        style={{
          left: `${((durationRange[0] - durationOptions[0].value) /
            (durationOptions[durationOptions.length - 1].value -
              durationOptions[0].value)) *
            100}%`,
          right: `${
            100 -
            ((durationRange[1] - durationOptions[0].value) /
              (durationOptions[durationOptions.length - 1].value -
                durationOptions[0].value)) *
              100
          }%`,
        }}
      />
    </div>
  </div>

  {/* Labels */}
  <div className="duration-labels">
    {durationOptions.map((d) => (
      <span key={d.value}>{d.label}</span>
    ))}
  </div>


  
  
  <p className="flter_renzess">
    <span className="lft_areea">Min:{" "} 
	 <span className="flt_tx">
	 {durationOptions.find((d) => d.value === durationRange[0])?.label ||
      durationRange[0] + "m"}{" "}
	 </span>
	</span>  
	<span className="rft_areea">Max:{" "} 
	 <span className="flt_tx">
	 {durationOptions.find((d) => d.value === durationRange[1])?.label ||
      durationRange[1] + "m"}
	 </span>
	</span>
  </p>
  
</div>



		<div className="flt_listings times_filtter">
  <h4>Time of day</h4>
  <div className="ckess_listts">
    <ul>
      {[
        { label: "Morning : Before 12:00", value: "morning" },
        { label: "Afternoon : After 12:00", value: "afternoon" },
        { label: "Evening : After 6:00", value: "evening" },
      ].map((item) => (
        <li key={item.value}>
          <div className="slt bothsredoibtn">
            <label className="label--checkbox rft">
               <input
                className="checkbox"
                type="checkbox"
                name="timeOfDay" // same name for all => only one can be selected
                value={item.value}
                checked={timeOfDay === item.value}
                onChange={() => setTimeOfDay(item.value)}
              />
              <strong>{item.label}</strong>
            </label>
          </div>
        </li>
      ))}
    </ul>
  </div>
</div>

		
		


        {/* Example filter options 
        <div className="filter-section">
          <label>Price Range</label>
          <input type="range" min="100" max="10000" />
        </div>

        <div className="filter-section">
          <label>City</label>
          <input type="text" placeholder="Enter city name" />
        </div>

        <button className="apply-btn" onClick={onApply}>
          Apply
        </button>
		*/}
      </div>
      		<div className="filltr_botmms">
		<button type="button" className="box_none" onClick={handleClear}>
  Clear All
</button>

		<button type="button" className="box_show" onClick={handleApply}>
  Show Results
</button>

		</div>
      </div>
    </div>
  );
}

export default Filter;
